import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/ai-search-optimization-guide")(blogRouteOptions("ai-search-optimization-guide"));
